String.prototype.format = function () {
  if (arguments.length === 0) return this
  let str = this
  for (let i = 0; i < arguments.length; i++) {
    const re = new RegExp('\\{' + i + '\\}', 'gm')
    str = str.replace(re, arguments[i])
  }
  return str
}

String.prototype.padLeft = function (len, ch) {
  ch = typeof ch === 'undefined' ? ' ' : ch
  let s = String(this)
  while (s.length < len) s = ch + s
  return s
}

export function getAllMethodNames(obj, excludeMethodName = [], lastClas) {
  let methods = []
  let proto = obj

  do {
    Object.getOwnPropertyNames(proto).forEach((name) => {
      if (
              typeof proto[name] === 'function' &&
              !excludeMethodName.includes(name)
      ) {
        methods.push(name)
      }
    })
    proto = Object.getPrototypeOf(proto)
  } while (!lastClas || proto instanceof lastClas)

  return methods
}

if (!Array.prototype.findLast) {
  Object.defineProperty(Array.prototype, 'findLast', {
    value: function (callback, thisArg) {
      if (callback) {
        for (let i = this.length - 1; i >= 0; i--) {
          if (callback.call(thisArg, this[i], i, this)) {
            return this[i]
          }
        }
      }
      return undefined
    },
    writable: true,
    configurable: true,
    enumerable: false
  })
}

export async function delay(seconds = 0, type = 1) {
  return new Promise(resolve => setTimeout(resolve, type === 1 ? seconds * 1000 : seconds));
}